import { fetcher } from "helpers/fetcher";

import { TGetTagTicketCountReq, TGetTagTicketCountRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getTagTicketCount = async (payload: TGetTagTicketCountReq) => {
  return await fetcher<TGetTagTicketCountRes, any>(
    ENDPOINT.MANAGEMENT.GET_TAG_TICKET_COUNT,
    {
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
      },
      urlData: { idTag: payload.urlData.idTag },
    }
  );
};

export const queryGetTagTicketCount = async (
  payload: TGetTagTicketCountReq
) => {
  return await getTagTicketCount(payload);
};

queryGetTagTicketCount._key = (payload?: TGetTagTicketCountReq) => [
  ENDPOINT.MANAGEMENT.GET_TAG_TICKET_COUNT.url,
  payload,
];
